import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "containerServices" }
const _hoisted_2 = { class: "titleWrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { computed, inject } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  setup(__props) {

const store: any = inject(`store`);
const displayWidth: any = inject(`displayWidth`);
const router: any = inject(`router`);
const servicesCardArray = store.getters.getServicesCardArray;
const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_SectionHeader, {
      title: "Services",
      id: "services",
      text: "At our digital marketing agency, we offer a range of services to help\r\n      businesses grow and succeed online. These servicesinclude:"
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesCardArray), (card) => {
        return (_openBlock(), _createBlock(_component_BaseCard, {
          styleProp: card.style,
          key: card.name,
          class: _normalizeClass({card:true,mobile:computedDisplayWidth.value})
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", {
                class: "title",
                style: _normalizeStyle({ backgroundColor: card.textBack })
              }, _toDisplayString(card.name), 5)
            ]),
            _createElementVNode("img", {
              src: card.img,
              alt: card.alt,
              class: "image"
            }, null, 8, _hoisted_3),
            _createElementVNode("a", {
              onClick: ($event: any) => (_unref(router).push({ path: card.to, query: { name: card.name } })),
              class: "more"
            }, [
              _withDirectives(_createElementVNode("img", {
                class: "icon",
                src: card.arrow,
                alt: "Arrow"
              }, null, 8, _hoisted_5), [
                [_directive_ripple]
              ]),
              _createElementVNode("p", {
                class: "text",
                style: _normalizeStyle({ color: card.style == `black` ? `white` : `black` })
              }, " Learn More ", 4)
            ], 8, _hoisted_4)
          ]),
          _: 2
        }, 1032, ["styleProp", "class"]))
      }), 128))
    ])
  ]))
}
}

})